// src/components/Header/navLinks.js

// Icons comune
import homeIcon from "../../assets/svg/material-symbols--home-outline-rounded.svg";
import calendarIcon from "../../assets/svg/mdi--calendar-outline.svg";
import calendarTextIcon from "../../assets/svg/mdi--calendar-text-outline.svg";
import calendarNewIcon from "../../assets/svg/mdi--calendar-today-outline.svg";
import addIcon from "../../assets/svg/mdi--calendar-plus-outline.svg";
import groupsIcon from "../../assets/svg/material-symbols--group-outline.svg";
import instrIcon from "../../assets/svg/mdi--account-cog-outline.svg";
import examIcon from "../../assets/svg/mdi--book-clock-outline.svg";
import categoriiIcon from "../../assets/svg/mdi--category-plus-outline.svg";
import videoIcon from "../../assets/svg/material-symbols--book-outline.svg";
import menuIcon from "../../assets/svg/material-symbols--menu-rounded.svg";
import reviewsIcon from "../../assets/svg/material-symbols--star-outline-rounded.svg";
import notificationIcon from "../../assets/svg/mingcute--notification-line.svg";
import messageIcon from "../../assets/svg/tabler--message.svg";
import enrollIcon from "../../assets/svg/material-symbols--group-add-outline.svg";
import backIcon from "../../assets/svg/material-symbols--arrow-back-rounded.svg";
import patternsIcon from "../../assets/svg/material-symbols--file-copy-outline.svg";
import templatesIcon from "../../assets/svg/material-symbols--edit-outline-sharp.svg";

// Student
import testIcon from "../../assets/svg/material-symbols--book-outline.svg";
import examStudentIcon from "../../assets/svg/mdi--book-clock-outline.svg";
import practicalExamIcon from "../../assets/svg/material-symbols--car-tag-outline.svg";
import phoneIcon from "../../assets/svg/phone.svg";
import studentVideoIcon from "../../assets/svg/mdi--play-circle-outline.svg";

// Instructor

// Professor
import studentsIcon from "../../assets/svg/graduate.svg";
import { normalizeRole, ROLES } from "../../auth/access";
import {
   isExamInstructorProfile,
   isSuperiorInstructorType,
} from "../../constants/instructors";

function buildInstructorLinks(instructor) {
   const links = [
      { link: "/instructor", text: "Acasă", icon: homeIcon },
      {
         link: "/instructor/orarul-meu",
         text: "Orarul Meu",
         icon: calendarIcon,
         // ca „Lecții practice” la admin: meniul duce în calendarul de acum; altfel, după „Calendar nou”,
         // instructorul rămânea mereu în calendarul nou (nu are alt drum înapoi)
         calendarChoice: "v1",
      },
      { link: "/instructor/videoclipuri", text: "Video", icon: studentVideoIcon },
   ];

   if (isSuperiorInstructorType(instructor?.instructorType)) {
      links.push({
         link: "/instructor/orar-practice",
         text: "Orar practice",
         icon: calendarTextIcon,
         calendarChoice: "v1",
      });
      // Aceleasi recenzii ca la manager, dar doar in citire.
      links.push({
         popup: "adminReviews",
         text: "Recenzii",
         icon: reviewsIcon,
         badgeKey: "adminReviews",
      });
   }

   if (isExamInstructorProfile(instructor)) {
      links.push({
         link: "/instructor/interne",
         text: "Orar interne",
         icon: calendarTextIcon,
      });
   }

   return links;
}

export function getLinksForRole(roleRaw, options = {}) {
   const role = normalizeRole(roleRaw);
   const instructor = options?.instructor || null;

   const map = {
      [ROLES.USER]: [
         // fără „group”: sus, fără titlu; apoi grupurile, cu titlul lor (Header.jsx).
         // Pe telefon bara de jos ia primele 4: Acasă, Calendar, Mesaje, Programare.
         { link: "/student", text: "Acasă", icon: homeIcon },
         { link: "/student/calendar", text: "Calendar", icon: calendarIcon },
         { popup: "staffChat", text: "Mesaje", icon: messageIcon, badgeKey: "staffChat" },
         { popup: "sAddProg", text: "Programare", icon: addIcon, group: "Practică" },
         {
            popup: "studentReservations",
            text: "Rezervări",
            icon: calendarIcon,
            group: "Practică",
         },
         {
            popup: "practicalExamBooking",
            text: "Ex. practic",
            icon: practicalExamIcon,
            group: "Practică",
         },
         { link: "/student/test", text: "Testare", icon: testIcon, group: "Teorie" },
         {
            link: "/student/exam",
            text: "Ex. Teoretic",
            icon: examStudentIcon,
            group: "Teorie",
         },
         {
            link: "/student/videoclipuri",
            text: "Video",
            icon: studentVideoIcon,
            group: "Teorie",
         },
         // „Notificări” la elev: clopoțelul din rândul de sus (StudentMobileTopBar)
      ],

      [ROLES.INSTRUCTOR]: buildInstructorLinks(instructor),

      [ROLES.PROFESSOR]: [
         { link: "/professor", text: "Acasă", icon: homeIcon },
         { link: "/professor/students", text: "Studenți", icon: studentsIcon },
         { link: "/professor/testare", text: "Testare", icon: testIcon },
         { link: "/professor/groups", text: "Grupe", icon: groupsIcon },
      ],

      [ROLES.MANAGER]: [
         { link: "/manager", text: "Acasă", icon: homeIcon },
         //{
         //   link: "/manager/orar-max",
         //   text: "Lecții practice (MAX)",
         //   icon: calendarIcon,
         //},
         // calendarul nou (al doilea în meniu) și cel de acum, separat; linkul ține minte alegerea
         // (calendarV2Access), ca „Lecții practice” să nu treacă singur în calendarul nou
         {
            link: "/manager/calendar-nou",
            // în meniu: „Calendar” + eticheta „Nou” (textul întreg nu încape lângă etichetă)
            text: "Calendar",
            icon: calendarNewIcon,
            calendarChoice: "v2",
            tag: "Nou",
         },
         {
            link: "/manager/orar-extreme",
            text: "Lecții practice",
            icon: calendarIcon,
            calendarChoice: "v1",
         },
         {
            link: "/manager/interne",
            text: "Examen practic",
            icon: calendarTextIcon,
         },
         {
            popup: "staffChat",
            text: "Mesaje",
            icon: messageIcon,
            badgeKey: "staffChat",
         },
         {
            link: "/manager/instructors",
            text: "Personal",
            icon: instrIcon,
         },
         { popup: "startExam", text: "Examen teoretic", icon: examIcon },
         {
            popup: "studentEnroll",
            text: "Înscriere",
            icon: enrollIcon,
         },
         // paginile folosite mai rar: în submeniu (getMoreLinksForRole)
         { submenu: "more", text: "Administrare", icon: menuIcon },
      ],

      [ROLES.ADMIN]: [
         { link: "/admin", text: "Acasă", icon: homeIcon },
         //{
         //   link: "/admin/orar-max",
         //   text: "Lecții practice (MAX)",
         //   icon: calendarIcon,
         //},
         // calendarul nou (al doilea în meniu) și cel de acum, separat; linkul ține minte alegerea
         // (calendarV2Access), ca „Lecții practice” să nu treacă singur în calendarul nou
         {
            link: "/admin/calendar-nou",
            // în meniu: „Calendar” + eticheta „Nou” (textul întreg nu încape lângă etichetă)
            text: "Calendar",
            icon: calendarNewIcon,
            calendarChoice: "v2",
            tag: "Nou",
         },
         {
            link: "/admin/orar-extreme",
            text: "Lecții practice",
            icon: calendarIcon,
            calendarChoice: "v1",
         },
         {
            link: "/admin/interne",
            text: "Orar interne",
            icon: calendarTextIcon,
         },
         {
            popup: "staffChat",
            text: "Mesaje",
            icon: messageIcon,
            badgeKey: "staffChat",
         },
         {
            link: "/admin/instructors",
            text: "Personal",
            icon: instrIcon,
         },
         //{
         //   link: "/chatbot",
         //   text: "Chatbot",
         //   icon: chatbotIcon,
         //},
         { popup: "startExam", text: "Examen teoretic", icon: examIcon },
         {
            popup: "studentEnroll",
            text: "Înscriere",
            icon: enrollIcon,
         },
         // paginile folosite mai rar: în submeniu, în locul meniului (vezi mai jos)
         { submenu: "more", text: "Administrare", icon: menuIcon },
      ],
   };

   return map[role] || [];
}

/**
 * Paginile folosite mai rar: „Administrare" din meniu nu deschide o pagină, ci
 * înlocuiește linkurile curente cu acestea; „Înapoi" revine la meniul
 * principal (pe „Administrare” apare punctul dacă e ceva necitit înăuntru).
 * Rolurile fără astfel de pagini primesc o listă goală.
 */
export function getMoreLinksForRole(roleRaw) {
   const role = normalizeRole(roleRaw);

   const map = {
      [ROLES.MANAGER]: [
         { back: true, text: "Înapoi", icon: backIcon },
         // „De sunat”: elevii de sunat după lecții (din alte școli / după curs)
         { link: "/manager/de-sunat", text: "De sunat", icon: phoneIcon },
         {
            popup: "adminReviews",
            text: "Recenzii",
            icon: reviewsIcon,
            badgeKey: "adminReviews",
         },
         // „Notificări”: tot ce a trimis aplicația (elevilor și personalului)
         { link: "/manager/notificari", text: "Notificări", icon: notificationIcon },
      ],
      [ROLES.ADMIN]: [
         { back: true, text: "Înapoi", icon: backIcon },
         // „De sunat”: elevii de sunat după lecții (din alte școli / după curs)
         { link: "/admin/de-sunat", text: "De sunat", icon: phoneIcon },
         {
            popup: "adminReviews",
            text: "Recenzii",
            icon: reviewsIcon,
            badgeKey: "adminReviews",
         },
         // biletele de examen și de teorie, cu categoriile: un singur editor
         { link: "/admin/intrebari", text: "Întrebări", icon: categoriiIcon },
         {
            popup: "studentVideoLibrary",
            text: "Videoclipuri",
            icon: videoIcon,
         },
         // textele trimise automat; „Notificări” — ce s-a trimis de fapt
         {
            link: "/admin/mesaje-automate",
            text: "Mesaje automate",
            icon: templatesIcon,
         },
         { link: "/admin/notificari", text: "Notificări", icon: notificationIcon },
         { link: "/admin/jurnal", text: "Jurnal acțiuni", icon: examIcon },
         { link: "/admin/tipare", text: "Tipare", icon: patternsIcon },
      ],
   };

   return map[role] || [];
}
